import { SagaIterator } from "redux-saga";
import { call, put } from "redux-saga/effects";
import { HttpResponseTypeEnum } from "../core/enumerations/ServerRequestStatusEnum";
import { chatRedux } from "../redux/chat-redux/ChatRedux";

export function* createProjectGroupSaga(
  api: any,
  action: any
): SagaIterator {
  try {
    const response = yield call(
      api.createProjectGroupChat,
      action.payload
    );
    if (
      response.status === HttpResponseTypeEnum.Success ||
      response.status === HttpResponseTypeEnum.userCreated
    ) {
      yield put(
        chatRedux.actions.createProjectGroupSuccess(response.data)
      );
    } else {
      yield put(
        chatRedux.actions.createProjectGroupFailure(response.data)
      );
    }
  } catch (error) {
    yield put(chatRedux.actions.createProjectGroupFailure(error));
  }
}

export function* getProjectGroupDetailsSaga(
  api: any,
  action: any
): SagaIterator {
  try {
    const response = yield call(
      api.getProjectGroupChatDetails,
      action.payload
    );
    if (
      response.status === HttpResponseTypeEnum.Success ||
      response.status === HttpResponseTypeEnum.userCreated
    ) {
      yield put(
        chatRedux.actions.getProjectGroupDataSuccess(response.data)
      );
    } else {
      yield put(
        chatRedux.actions.getProjectGroupDataFailure(response.data)
      );
    }
  } catch (error) {
    yield put(chatRedux.actions.getProjectGroupDataFailure(error));
  }
}

export function* getAllCollabaratorsByProjectIdSaga(
  api: any,
  action: any
): SagaIterator {
  try {
    const response = yield call(
      api.getAllCollaboratorsByProjectId,
      action.payload
    );
    if (
      response.status === HttpResponseTypeEnum.Success ||
      response.status === HttpResponseTypeEnum.userCreated
    ) {
      yield put(
        chatRedux.actions.getAllCollaboratorByProjectIdSuccess(response.data)
      );
    } else {
      yield put(
        chatRedux.actions.getAllCollaboratorByProjectIdFailure(response.data)
      );
    }
  } catch (error) {
    yield put(chatRedux.actions.getAllCollaboratorByProjectIdFailure(error));
  }
}
